import _get from "lodash.get";
import { authFactory as authInstance } from "../factory";
import saveTimeToken from "../provider/timeToken";

const login = async data => {
  const response = await authInstance.post("/api/auth/login", data);

  const expiration = _get(response, "data.expires_in");

  if (!expiration) {
    throw {
      message: "No expires_in present in the response",
      expirationError: true
    };
  }

  saveTimeToken(expiration);

  return response;
};

const resetPassword = async data => {
  data.version = 3;
  const response = await authInstance.post("/api/auth/password/email", data);
  return response.data;
};

const resetPasswordVerify = async data => {
  const response = await authInstance.get(`/api/auth/password/reset/${data}`);
  return response.data;
};

const forgotPassword = async (token, data) => {
  const response = await authInstance.post(`/api/auth/password/reset/${token}`, data);
  return response.data;
};

export { resetPassword };

export { resetPasswordVerify };

export { forgotPassword };

export default login;
